import LanguageValueList from "./LanguageValueList";

function isArrayEmptyOrFalsy(arr) {
    // Check if array contains only one element which is an empty string or falsy value
    return arr.length === 1 && (arr[0] === "" || arr[0] === null || arr[0] === undefined || arr[0].trim() === "");
}

export default class Person {
    constructor(name = new LanguageValueList(), email = "", id = "") {
    // constructor(name = new LanguageValueList(), email = [], id = "") {
        this.name = name;
        this.email = email;
        this.id = id;
    }

    // Getters and Setters
    getName() {
        return this.name;
    }

    setName(name) {
        if (name instanceof LanguageValueList) {
            this.name = name;
        } else {
            throw new Error("Street address must be an instance of LanguageValueList");
        }
    }

    getId() {
        return this.id;
    }

    setId() {
        return this.id;
    }

    getEmails() {
        return this.email;
    }

    setEmails(email) {
        this.email = email;
    }

    isEmpty() {
        // return !isArrayEmptyOrFalsy(this.email) && this.name.getValues().length === 0 && this.id === "";
        return this.email === "" && this.name.getValues().length === 0 && this.id === "";
    }

    toJSON() {
        return {
            name: this.name.toJSON(),
            email: this.email,
            id: this.id,
        };
    }
}
